import { v4 as uuidv4, validate as uuidValidate } from 'uuid';

// eslint-disable-next-line import/prefer-default-export
export function getInitialAnonymousAnalyticsToken(): string {
  const anonymousAnalyticsToken = localStorage.getItem('anonymousAnalyticsToken');

  const isValid = uuidValidate(anonymousAnalyticsToken || '');

  if (!anonymousAnalyticsToken || !isValid) {
    const newAnonymousAnalyticsToken = uuidv4();
    localStorage.setItem('anonymousAnalyticsToken', newAnonymousAnalyticsToken);
    return newAnonymousAnalyticsToken;
  }
  return anonymousAnalyticsToken;
}
